import React, { useState, useEffect } from 'react';
import {
  Modal,
  Text,
  BlockStack,
  TextField,
} from '@shopify/polaris';

const CreateSceneModal = ({ 
  isOpen, 
  onClose, 
  onCreateScene,
  isCreating 
}) => {
  const [sceneName, setSceneName] = useState('');
  const [storyName, setStoryName] = useState('');
  const [numScenes, setNumScenes] = useState('1');

  // Reset form when modal opens/closes
  useEffect(() => {
    if (!isOpen) {
      setSceneName('');
      setStoryName('');
      setNumScenes('1');
    } else {
      setSceneName('');
      setStoryName('');
      setNumScenes('1');
    }
  }, [isOpen]);

  const handleCreateScene = async () => {
    const count = Math.max(1, parseInt(numScenes || '1', 10));
    if (!sceneName.trim()) {
      return;
    }
    if (!storyName.trim()) {
      return;
    }
    await onCreateScene({
      sceneName: sceneName.trim(),
      storyName: storyName.trim(),
      numScenes: count,
    });
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={<div style={{padding: '16px'}}>{'Create New Scenes'}</div>}
      primaryAction={{
        content: 'Create',
        onAction: handleCreateScene,
        loading: isCreating,
        disabled: !sceneName.trim() || !storyName.trim() || parseInt(numScenes || '0', 10) < 1,
      }}
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: onClose,
        },
      ]}
      footer={<div style={{padding: '16px'}}></div>}
    >
      <BlockStack gap="400">
        <TextField
          label="Story Name"
          value={storyName}
          onChange={setStoryName}
          placeholder="Enter story name..."
          autoComplete="off"
          maxLength={80}
          helpText="Name of the story these scenes belong to"
        />
        <TextField
          label="Scene Name"
          value={sceneName}
          onChange={setSceneName}
          placeholder="Enter scene name..."
          autoComplete="off"
          maxLength={40}
          helpText="Enter a name for your new scene"
        />
        <TextField
          label="Number of Scenes"
          type="number"
          value={numScenes}
          onChange={(v) => setNumScenes(v)}
          autoComplete="off"
          min={1}
          max={50}
          helpText="How many scenes to create"
        />
      </BlockStack>
    </Modal>
  );
};

export default CreateSceneModal;
